import { memo, useState } from "react";

import { useAppContext } from "../../../../2_ksbHub/context/appContext.js";
import { useHusibuechContext } from "../../context/husibuechContext.js";
import DeadlineAssignmentsTFlip from "./DeadlineAssignmentsTFlip.js";
import DeadlineAssignmentsList from "./DeadlineAssignmentsList.js";
import MiddleBox from "../1_Boxes/MiddleBox.js";
import { getBoxHeaderTitle } from "../../components/1_Boxes/getBoxHeaderTitle.js";
import { getBoxHeaderOptions } from "../../components/1_Boxes/getBoxHeaderOptions.js";
import BoxHeader from "../../components/1_Boxes/BoxHeader.js";

function DeadlineAssignments({
  type,
  flipAssignment,
  setFlipAssignment,
  single,
}) {
  const { currentUser } = useAppContext;
  const {
    isAStudent,
    isATeacher,
    isAnAdmin,
    isALeader,
    selectedCourse,
    showCourseAssignmentOnly,
  } = useHusibuechContext();

  const [teacherFlip, setTeacherFlip] = useState(true);

  // console.log("type, ", type)
  const shouldRenderPersonalList =
    (isALeader && type === "personal") ||
    (isAStudent && type === "studentView") ||
    (currentUser && type === "personalEmpty");
  // console.log("pers", shouldRenderPersonalList)

  const shouldRenderCoreCourseList = isALeader && type === "coreCourse";

  const boxHeaderTitle = getBoxHeaderTitle(
    isAStudent,
    isATeacher,
    isAnAdmin,
    selectedCourse,
    type,
    showCourseAssignmentOnly,
  );
  const boxHeaderOptions = getBoxHeaderOptions(type, single);

  return shouldRenderCoreCourseList && isALeader ? (
    <DeadlineAssignmentsTFlip single={single} />
  ) : (
    <>
      <BoxHeader
        title={boxHeaderTitle}
        options={boxHeaderOptions}
        flipAssignment={flipAssignment}
        setFlipAssignment={setFlipAssignment}
        flipTeacherAssignment={teacherFlip}
        setFlipTeacherAssignment={setTeacherFlip}
      />
      <MiddleBox>
        <DeadlineAssignmentsList
          type={shouldRenderPersonalList ? "personal" : "additional"}
        />
      </MiddleBox>
    </>
  );
}

export default memo(DeadlineAssignments);
